import React, { useEffect, useState } from 'react';
import DSButton from '../common/atoms/DSButton';
import DSIcon from '../common/atoms/DSIcon';
import DSModal from '../tailwind/molecules/DSModal';
import Skeleton from '../tailwind/atoms/Skeleton';
import { companyMailerApi } from '../../services';
import MailerBadge from './MailerBadge';
import MailerDevicePreview from './MailerDevicePreview';

const istTime = value => new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value)) + ' IST';

/**
 * The exact published revision one employee was sent, opened from a Recipients & status row.
 * request: { campaignId, contentMailerId, revision, customerId, name, detail, versionLabel, typeName, typeTone, deliveryText, deliveryTone } or null.
 * Read only; scope is "company:contract" so a reply for an earlier company is dropped.
 */
export default function SentEmailModal({ request, scope, onClose }) {
  const [state, setState] = useState(null);
  const [device, setDevice] = useState('desktop');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!request) return undefined;
    let active = true;
    setState({ loading: true });
    companyMailerApi.sent_email(request.campaignId, request.customerId, { content_mailer_id: request.contentMailerId, revision: request.revision })
      .then(response => ({ email: response.data }), err => err.response?.status === 404
        ? { missing: err.response.data?.message || "We can't show this email. Its saved copy is no longer available." }
        : { error: err.response?.data?.message || "Couldn't load the email. Check your connection and try again." })
      .then(result => { if (active && scope === sessionStorage.getItem('company_id') + ':' + sessionStorage.getItem('contract_id')) setState(result); });
    return () => { active = false; };
  }, [request, scope, attempt]);
  if (!request) return null;
  const email = state?.email;
  const name = request.name || 'this employee';
  const meta = <span className="flex flex-wrap items-center gap-ds-2 text-ts-sm text-gray-700">
    {request.typeName && <MailerBadge tone={request.typeTone || 'neutral'}>{request.typeName}</MailerBadge>}
    <span className="font-mono font-semibold tabular-nums text-gray-900">{request.versionLabel} · Revision {request.revision}</span>
    {email?.published_at && <span>Published <span className="font-mono tabular-nums">{istTime(email.published_at)}</span></span>}
    {request.deliveryText && <MailerBadge tone={request.deliveryTone || 'neutral'}>{request.deliveryText}</MailerBadge>}
    {email && email.current_revision > email.revision && <MailerBadge tone="brand">Revision <span className="font-mono tabular-nums">{email.current_revision}</span> is live now</MailerBadge>}
  </span>;
  return <DSModal centered destroyOnClose visible wrapClassName="benefit-mailer-modal [&_.ant-modal]:max-w-[calc(100vw-24px)] mailer-benefit-preview" width={email && device !== 'mobile' ? 1120 : 600} footer={null} onCancel={onClose}
    title={<div>Email sent to {name}{request.detail && <p className="mb-0 mt-1 font-mono text-ts-sm font-normal tabular-nums text-gray-600">{request.detail}</p>}</div>}>
    {email ? <>
      <MailerDevicePreview html={email.html} subject={email.subject} sender={email.sender || 'ekincare'} device={device} onDeviceChange={setDevice} status={meta} title={'Email sent to ' + name} />
      <p className="mx-6 mb-5 flex items-start gap-ds-2 rounded-ds-md bg-blue-100 p-ds-4 text-ts-sm leading-relaxed text-gray-700"><DSIcon size={16} name="info" className="mt-px text-blue-600" />Shown for {name}&apos;s current plan and grade. Plan-specific sections may differ from the day it was sent. Text, images and subject are exactly revision {email.revision}.</p>
    </> : <div className="space-y-4 p-ds-6">
      {meta}
      {!state || state.loading ? <Skeleton label={'Loading the email ' + name + ' was sent…'} className="h-64" />
        : state.missing ? <p className="!m-0 flex items-start gap-ds-2 rounded-ds-md bg-gray-100 p-ds-4 text-ts-sm text-gray-700"><DSIcon size={16} name="info" className="mt-px" />{state.missing}</p>
          : <div role="alert" className="flex flex-wrap items-center gap-ds-3 text-ts-sm text-red-800">{state.error} <DSButton size="small" onClick={() => setAttempt(value => value + 1)}>Retry</DSButton></div>}
    </div>}
  </DSModal>;
}
